import { z } from "zod"

// Run synchronously before hydration so validation never probes new Function.
z.config({ jitless: true })
